import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Setup() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Setup